import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ChipConnector } from '../ChipConnector/ChipConnector';
import { FilterChip } from '../FilterChip/FilterChip';
import { moveCollectionQuantifier, nextCollectionQuantifier, presentCollectionEntries, setCollectionQuantifier } from './collection-predicate';
import { pureOrNamePills, removeOrArm } from './CollectionChips.utils';
import { CollectionConditionChip } from './CollectionConditionChip/CollectionConditionChip';
import { collectionOperatorLabel } from './CollectionConditionChip/CollectionConditionChip.utils';
export const GetCollectionChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const CollectionChips = (param)=>{
    let { testId, fieldLabel, nounLabel, collection, toggleBiName, removeBiName, onChange } = param;
    const { CollectionChipsTestIds } = useMemo(()=>GetCollectionChipsTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const toggleQuantifier = (quantifier)=>{
        const target = nextCollectionQuantifier(collection, quantifier);
        if (target === quantifier) return;
        onChange(moveCollectionQuantifier(collection, quantifier, target));
    };
    const renderQuantifier = (quantifier, predicate)=>{
        const orPills = pureOrNamePills(predicate);
        if (orPills == null) {
            return /*#__PURE__*/ _jsx(CollectionConditionChip, {
                testId: CollectionChipsTestIds.Chip(quantifier),
                fieldLabel: fieldLabel,
                nounLabel: nounLabel,
                quantifier: quantifier,
                predicate: predicate,
                toggleBiName: toggleBiName,
                removeBiName: removeBiName,
                onToggleQuantifier: ()=>toggleQuantifier(quantifier),
                onRemove: ()=>onChange(setCollectionQuantifier(collection, quantifier, undefined))
            });
        }
        return orPills.map((pill, pillIndex)=>/*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    pillIndex > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: CollectionChipsTestIds.OrPillConnector(quantifier, pill.armIndex),
                        tone: "or"
                    }),
                    /*#__PURE__*/ _jsx(FilterChip, {
                        testId: CollectionChipsTestIds.OrPill(quantifier, pill.armIndex),
                        fieldLabel: fieldLabel,
                        operator: {
                            label: collectionOperatorLabel(quantifier, t),
                            onToggle: ()=>toggleQuantifier(quantifier),
                            biName: toggleBiName
                        },
                        valueLabel: pill.valueLabel,
                        onRemove: ()=>onChange(removeOrArm(collection, quantifier, predicate, pill.armIndex)),
                        removeBiName: removeBiName,
                        tone: "settings"
                    })
                ]
            }, pill.armIndex));
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentCollectionEntries(collection).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: CollectionChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    renderQuantifier(quantifier, predicate)
                ]
            }, quantifier);
        })
    });
};
